import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteCompanyModal = ({ show, handleClose, company }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center p-4">
        <h5 className="mb-3">Delete Company</h5>

        <p>
          Are you sure you want to delete{" "}
          <strong>{company?.name}</strong>?
        </p>

        <div className="d-flex justify-content-center gap-2 mt-3">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger">
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteCompanyModal;